<template>
  <l-marker
    v-if="markerIcon&&show"
    :lat-lng="markerPosition"
    :icon="markerIcon"
    @click="onClick"
  >
    <l-tooltip :options="{permanent:this.$props.tooltips}">{{this.$props.hydrantObj.durchlaufmenge}}</l-tooltip>
  </l-marker>
</template>

<script>
import { LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import Swal from 'sweetalert2';

export default {
  name: "Hydrant",
  components: { LMarker, LTooltip },
  props: {
    hydrantObj: Object,
    zoom: Number,
    markerPosition: Array,
    tooltips: Boolean,
    hydrantenBearbeiten: Boolean,
    hydrantenEntfernen: Boolean
  },
  data() {
    return {
      baseIconSize: 40, // Pixel bei Zoom 18
      markerIcon: L.icon({
        iconUrl: require("@/assets/KartenIcons/Hydrant.svg"),
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -20],
        tooltipAnchor: [0, -40]
      }),
      show: true
    };
  },
  methods: {
    createIcon(zoom) {
      const size = this.baseIconSize * Math.pow(2, (zoom - 18) * 0.5);
      return L.icon({
        iconUrl: require("@/assets/KartenIcons/Hydrant.svg"),
        iconSize: [size, size],
        iconAnchor: [size / 2, size],
        popupAnchor: [0, -size / 2],
        tooltipAnchor: [0, -size]
      });
    },
    onMapReady(map) {
      this.mapObject = map;
      map.invalidateSize();
    },
    onClick(){
      switch(true){
        case this.$props.hydrantenBearbeiten:
          this.$emit('hydrantBearbeiten', this.$props.hydrantObj);
          return;
        case this.$props.hydrantenEntfernen:
          this.$emit('hydrantEntfernen', this.$props.hydrantObj);
          return;
        default:
          console.log("Hydrant angeklickt: ", this.$props.hydrantObj);
          var footerText = '<a href="https://www.google.com/maps/place/' + this.$props.hydrantObj.position.x + '+' + this.$props.hydrantObj.position.y + '" target="_blank" style="color: black !important; font-family: Helvetica, Arial, sans-serif !important; text-decoration: none !important">Zu Google Maps </a>';
          console.log(this.$props.hydrantObj);
          let titleText = this.$props.hydrantObj.name + '<br><hr>Durchmesser: ' + this.$props.hydrantObj.durchlaufmenge + ' mm';
          Swal.fire({
              title: titleText,
              text: this.$props.hydrantObj.bemerkung,
              footer: footerText
          })
          break;
      }
    }
  },
  created() {
    this.markerIcon = this.createIcon(18);
  },
  mounted() {

  }
};
</script>

<style scoped>
.markerIcon{
    max-height: 2.5rem !important;
    filter: drop-shadow(0 0 0.05rem rgb(53, 53, 53));
}
</style>